import style from './ErrorPage.module.scss';

type ErrorPageProps = {
  text: string;
  onRetry?: () => void;
};

export const ErrorPage = ({ text, onRetry }: ErrorPageProps) => {
  return (
    <section className={style.errorContainer}>
      <h1 className={style.message}>{text}</h1>

      {onRetry && (
        <button className={style.retryButton} onClick={onRetry} type="button">
          Попробовать снова
        </button>
      )}
    </section>
  );
};
